import { useCallback } from 'react';

import { useMsal } from '@azure/msal-react';
import {
  UserDialog,
  UserDialogContainer,
  UserDialogList,
  UserDialogListItem,
  UserDialogUserEmail,
  UserDialogUserInfo,
  UserDialogUserName,
  useUserDialogListState,
} from '@twilio-paste/core/user-dialog';
import * as log from 'loglevel';

export function UserMenuActions() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const name = account?.name || '';
  const email = account?.username || '';

  const userDialogList = useUserDialogListState();

  const handleLogoutRedirect = useCallback(() => {
    instance.logoutRedirect().catch((error) => log.error(error));
  }, [instance]);

  return (
    <UserDialogContainer name={name}>
      <UserDialog aria-label="user-menu">
        <UserDialogUserInfo>
          <UserDialogUserName>{name}</UserDialogUserName>
          <UserDialogUserEmail>{email}</UserDialogUserEmail>
        </UserDialogUserInfo>
        <UserDialogList {...userDialogList} aria-label="User menu actions">
          <UserDialogListItem
            {...userDialogList}
            onSelect={handleLogoutRedirect}
          >
            Logout
          </UserDialogListItem>
        </UserDialogList>
      </UserDialog>
    </UserDialogContainer>
  );
}
